import React, { useEffect } from 'react';
import DashboardLayout from '../components/Nav'; // adjust path if needed
import LogsTable from '../components/LogsTable';

export default function LogsPage() {

  useEffect(() => {
    document.title = "Network Logs | IP Intelligence Portal";
  }, []);
    return (
      <DashboardLayout>
        <LogsTable />
      </DashboardLayout>
    );
  }